import { render, staticRenderFns } from "./ztlb.vue?vue&type=template&id=608fd94c&scoped=true&"
import script from "./ztlb.vue?vue&type=script&lang=js&"
export * from "./ztlb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608fd94c",
  null
  
)

export default component.exports